export enum RETURN_ORDER_TYPES {
	ONLINE = 'online',
	STORE = 'store',
}
